import { ReactNode } from "react";
import { HintedHead } from "~/components/ui/hint-tooltip";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "~/components/ui/table";
import { cn } from "~/lib/utils";
import { SearchEntityType } from "~/services/search";
import { EntityTypeCell } from "./EntityTypeCell";

export interface Column<Row> {
  label: string;
  hint?: string;
  cell: (row: Row) => ReactNode;
  /** Left-aligned text, rather than the default right-aligned figure. */
  isText?: boolean;
  isEmphasized?: boolean;
}

/** A row per entity type and a column per figure, the shape of every Index tab table. */
export const EntityTypeTable = <Row extends { entity_type: SearchEntityType }>({
  label,
  rows,
  columns,
}: {
  label: string;
  rows: Row[];
  columns: Column<Row>[];
}) => (
  <div className="rounded-lg border border-border">
    <Table aria-label={label}>
      <TableHeader>
        <TableRow>
          <TableHead className="w-40">Type</TableHead>
          {columns.map((column) => (
            <TableHead key={column.label} className={cn(!column.isText && "text-right")}>
              <HintedHead label={column.label} hint={column.hint} />
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.entity_type}>
            <EntityTypeCell entityType={row.entity_type} />
            {columns.map((column) => (
              <TableCell
                key={column.label}
                className={cn(
                  !column.isText && "text-right tabular-nums",
                  column.isEmphasized && "font-semibold"
                )}
              >
                {column.cell(row)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
